import { useEffect, useState } from 'react'
import { useFetch } from '..'
import { FetchHookProps, FetchState } from './types'

export const useFetchedState = <T,>({ ...hookProps }: FetchHookProps) => {
  const [fetchedState, setFetchedState] = useState<FetchState<T>>()

  const { fetchState, execute } = useFetch<T>({ ...hookProps })

  useEffect(() => {
    setFetchedState(fetchState)
  }, [fetchState])

  return { fetchedState, execute }
}
